import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/bmap',
      name: 'bmap',
      component: () => import(/* webpackChunkName: "BMap" */ './views/BMap.vue'),
      meta: {
        title: '百度地图',
      },
    },
    {
      path: '/service',
      name: 'service',
      component: () => import(/* webpackChunkName: "Service" */ './views/Service.vue'),
      meta: {
        title: '考勤服务VIP',
      },
    },
    {
      path: '/topup',
      name: 'topup',
      component: () => import(/* webpackChunkName: "TopUp" */ './views/TopUp.vue'),
      meta: {
        title: '购买考勤服务',
      },
    },
    {
      path: '/service_agreement',
      name: 'service_agreement',
      component: () => import(/* webpackChunkName: "ServiceAgreement" */ './views/ServiceAgreement.vue'),
      meta: {
        title: '服务协议',
      },
    },
    {
      path: '/real_name',
      name: 'real_name',
      component: () => import(/* webpackChunkName: "RealName" */ './views/RealName.vue'),
      meta: {
        title: '实名认证协议',
      },
    },
    {
      path: '/privacy_agreement',
      name: 'privacy_agreement',
      component: () => import(/* webpackChunkName: "PrivacyAgreement" */ './views/PrivacyAgreement.vue'),
      meta: {
        title: '墨计隐私政策',
      },
    },
    {
      path: '/register_agreement',
      name: 'register_agreement',
      component: () => import(/* webpackChunkName: "RegisterAgreement" */ './views/RegisterAgreement.vue'),
      meta: {
        title: '墨计用户服务协议',
      },
    },
    {
      path: '/help_instruction',
      name: 'help_instruction',
      component: () => import(/* webpackChunkName: "HelpInstruction" */ './views/HelpInstruction.vue'),
      meta: {
        title: '帮助说明',
      },
    },
    {
      path: '/wxlite_sms',
      name: 'wxlite_sms',
      component: () => import(/* webpackChunkName: "WxliteSMS" */ './views/WxliteSMS.vue'),
      meta: {
        title: ' ',
      },
    },
    {
      path: '/contract/sign',
      name: 'contract.sign',
      component: () => import(/* webpackChunkName: "contract.sign" */ './views/contract/sign/index.vue'),
      meta: {
        title: '',
      },
    },
    {
      path: '/attendance',
      name: 'attendance',
      component: () => import(/* webpackChunkName: "Attendance" */ './views/Attendance.vue'),
      meta: {
        title: '定位中',
      },
    },
    {
      path: '/mybank_guide',
      name: 'mybank_guide',
      component: () => import(/* webpackChunkName: "MybankGuide" */ './views/MybankGuide.vue'),
      meta: {
        title: '定位中',
      },
    },
    {
      path: '/vip_service_agreement',
      name: 'vip_service_agreement',
      component: () => import(/* webpackChunkName: "VipServiceAgreement" */ './views/VipServiceAgreement.vue'),
      meta: {
        title: '会员服务协议',
      },
    },
    {
      path: '/post_job_agreement',
      name: 'post_job_agreement',
      component: () => import(/* webpackChunkName: "PostJobAgreement" */ './views/PostJobAgreement.vue'),
      meta: {
        title: '墨计招工信息发布规则',
      },
    },
    {
      path: '/loc_test',
      name: 'loc_test',
      component: () => import(/* webpackChunkName: "LocTest" */ './views/LocTest.vue'),
      meta: {
        title: '定位测试',
      },
    },
    {
      path: '/download',
      name: 'download',
      component: () => import(/* webpackChunkName: "Download" */ './views/Download/index.vue'),
      meta: {
        title: '下载',
      },
    },
    {
      path: '/check_contract',
      name: 'check_contract',
      component: () => import(/* webpackChunkName: "CheckContract" */ './views/CheckContract.vue'),
      meta: {
        title: ' ',
      },
    },
  ],
});
